module.exports = __webpack_public_path__ + "static/media/feedback-thumbs-up.8e5181b4.svg";